module.exports = __webpack_public_path__ + "img/senegal.010dc497.svg";